// extracted by mini-css-extract-plugin
export var csatScore = "_lc-5";
export var header = "_lc-1";
export var panelWrapper = "_lc-2";
export var postPreview = "_lc-3";
export var rightContent = "_lc-0";
export var wrappingText = "_lc-4";